export const TOOL_TASK = 'disable-license-access-permissions';
export const TOOL_TITLE = 'Disable Module Access Permissions';
export const TOOL_PROGRESS_LABEL = 'Bulk license updating progress...';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once updating license finishes';
export const FILE_NAME = 'Disable-module-access-permissions-report';
export const FILE_HEADERS = {
    accountId: 'Account ID',
    accountName: 'Account Name',
    licenseId: 'License ID',
    licenseType: 'License Type',
    status: 'Action Status',
};

export const MODAL_WIDTH = 900;
